// Configuración principal de la aplicación Angular
import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { authInterceptor } from './core/domain/interceptors/auth.interceptor';
import { errorInterceptor } from './core/domain/interceptors/error.interceptor';
import { loadingInterceptor } from './core/domain/interceptors/loading.interceptor';
import { InitialDataRepository } from './core/domain/repositories/initial-data/initial-data.repository';
import { InitialDataRepositoryImplementation } from './core/infrastructure/repositories/initial-data/initial-data.repository.implementation';
import { LeadRepository } from './core/domain/repositories/lead/lead.repository';
import { LeadRepositoryImplementation } from './core/infrastructure/repositories/lead/lead.repository.implementation';
import { VehicleLookupRepository } from './core/domain/repositories/vehicle-lookup/vehicle-lookup.repository';
import { VehicleLookupRepositoryImplementation } from './core/infrastructure/repositories/vehicle-lookup/vehicle-lookup.repository.implementation';
import { TarifaRepository } from './core/domain/repositories/tarifa/tarifa.repository';
import { TarifaRepositoryImplementation } from './core/infrastructure/repositories/tarifa/tarifa.repository.implementation';
import { CatalogRepository } from './core/domain/repositories/catalog/catalog.repository';
import { CatalogRepositoryImplementation } from './core/infrastructure/repositories/catalog/catalog.repository.implementation';
import { AdvisorRepository } from './core/domain/repositories/advisor/advisor.repository';
import { AdvisorRepositoryImplementation } from './core/infrastructure/repositories/advisor/advisor.repository.implementation';
import { PaymentRepository } from './core/domain/repositories/payment/payment.repository';
import { PaymentRepositoryImplementation } from './core/infrastructure/repositories/payment/payment.repository.implementation';
import { CumuloRepository } from './core/domain/repositories/cumulo/cumulo.repository';
import { CumuloRepositoryImplementation } from './core/infrastructure/repositories/cumulo/cumulo.repository.implementation';
import { SarlaftRepository } from './core/domain/repositories/sarlaft/sarlaft.repository';
import { SarlaftRepositoryImplementation } from './core/infrastructure/repositories/sarlaft/sarlaft.repository.implementation';
import { ConsultableRisksRepository } from './core/domain/repositories/consultable-risks/consultable-risks.repository';
import { ConsultableRisksRepositoryImplementation } from './core/infrastructure/repositories/consultable-risks/consultable-risks.repository.implementation';
import { CotizacionRepository } from './core/domain/repositories/cotizacion/cotizacion.repository';
import { CotizacionRepositoryImplementation } from './core/infrastructure/repositories/cotizacion/cotizacion.repository.implementation';
import { PendingInvoicesRepository } from './core/domain/repositories/pending-invoices/pending-invoices.repository';
import { PendingInvoicesRepositoryImplementation } from './core/infrastructure/repositories/pending-invoices/pending-invoices.repository.implementation';
import { mockApiInterceptor } from '../mocks/mock-api.interceptor';
import { environment } from '../environments/environment';

// Los interceptores base siempre activos. El orden importa: auth → loading → error.
const baseInterceptors = [authInterceptor, loadingInterceptor, errorInterceptor];

// El mock interceptor solo se activa en desarrollo local (environment.useMocks)
const allInterceptors = environment.useMocks
  ? [...baseInterceptors, mockApiInterceptor]
  : baseInterceptors;

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(withInterceptors(allInterceptors)),
    // Enlace puerto → adaptador (arquitectura hexagonal)
    { provide: InitialDataRepository, useClass: InitialDataRepositoryImplementation },
    { provide: LeadRepository, useClass: LeadRepositoryImplementation },
    { provide: VehicleLookupRepository, useClass: VehicleLookupRepositoryImplementation },
    { provide: TarifaRepository, useClass: TarifaRepositoryImplementation },
    { provide: CatalogRepository, useClass: CatalogRepositoryImplementation },
    { provide: AdvisorRepository, useClass: AdvisorRepositoryImplementation },
    { provide: PaymentRepository, useClass: PaymentRepositoryImplementation },
    { provide: CumuloRepository, useClass: CumuloRepositoryImplementation },
    { provide: SarlaftRepository, useClass: SarlaftRepositoryImplementation },
    { provide: ConsultableRisksRepository, useClass: ConsultableRisksRepositoryImplementation },
    { provide: CotizacionRepository, useClass: CotizacionRepositoryImplementation },
    { provide: PendingInvoicesRepository, useClass: PendingInvoicesRepositoryImplementation },
  ],
};
